import { clstx } from '@payaca/utilities/cvaMerge';
import { FC, PropsWithChildren } from 'react';

type DivProps = React.ComponentProps<'div'>;

const SidebarLayout: FC<DivProps> = ({ children, className, ...rest }) => {
  return (
    <div
      className={clstx(
        'typography:prose bg-gray-50 overflow-y-auto @screen-md:overflow-hidden @screen-md:grid @screen-md:grid-cols-[minmax(0,1fr)_300px] size-full',
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

const PageBody: FC<DivProps> = ({ children, className, ...rest }) => {
  return (
    <div
      className={clstx('p-4 min-h-full overflow-y-auto', className)}
      {...rest}
    >
      {children}
    </div>
  );
};

const Sidebar: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="@screen-md:min-h-full bg-white border-gray-200 flex flex-col">
      <div className="flex flex-col grow">{children}</div>
    </div>
  );
};

const SidebarBody: FC<DivProps> = ({ children, className, ...rest }) => {
  return (
    <div
      className={clstx(
        'grow md:overflow-auto p-4 w-full max-md:grow',
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

const SidebarFooter: FC<DivProps> = ({ children, className, ...rest }) => {
  return (
    <div
      className={clstx(
        'shrink w-full p-4 border-gray-200 border-t-1',
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Object.assign(SidebarLayout, {
  Body: PageBody,
  Sidebar: Object.assign(Sidebar, {
    Body: SidebarBody,
    Footer: SidebarFooter,
  }),
});
